// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
import "@hotwired/turbo-rails"
import "controllers"
import "channels"

import "trix"
import "@rails/actiontext"
import * as bootstrap from "bootstrap"
import { configureActivityTracker } from "activity_tracker"


let popoverInstances = []

function initPopovers(root = document) {
  // Descartar instancias anteriores por si recargan parcial
  disposePopovers()

  const elements = root.querySelectorAll('[data-bs-toggle="popover"]')
  elements.forEach(el => {
    // Opcional: si usas data-bs-html="true" y confías en el HTML del servidor:
    // const opts = { html: true, sanitize: false, container: 'body' }
    const opts = { container: 'body', trigger: 'focus' }
    const instance = new bootstrap.Popover(el, opts)
    popoverInstances.push(instance)
  })
}

function disposePopovers() {
  popoverInstances.forEach(inst => inst.dispose())
  popoverInstances = []
}

// Inicializa en navegación Turbo
document.addEventListener('turbo:load', () => initPopovers(document))
document.addEventListener('turbo:load', () => configureActivityTracker())
document.addEventListener('DOMContentLoaded', () => configureActivityTracker(), { once: true })
// Si usas <turbo-frame>, re-inicializa cuando carguen
document.addEventListener('turbo:frame-load', (e) => initPopovers(e.target))
// Limpia antes de que Turbo guarde en caché el DOM
document.addEventListener('turbo:before-cache', () => {
  disposePopovers();
})
